import { EValidationRequestStatus } from './IGlobal';
import { EStageStatus, EValidatorStatus } from './IStatus';

export interface ISingleValidator {
    validatorRowId?: string;
    label: {
        name: string;
        description: string;
        photo: string;
        type: number;
        promoted: boolean;
        Key: string;
    };
    modifiedAt: Date | null;
    modifiedBy: {
        cabinet: string;
        emailContact: string;
        firstName: string;
        id: string;
        jobTitle: string;
        lastName: string;
        picture: string;
    } | null;
    principal: {
        childId: string;
        childName: string;
        jobTitle: string;
        picture: string;
        type: 'Personal' | 'Group' | 0 | 1;
    };
    role: {
        Key: string;
        id: string;
        name: string;
    };
    status: EValidatorStatus;
    validatorType: EValidatorType;
}

export const enum EValidatorType {
    Acknowledgement = 'Acknowledgement',
    Approval = 'Approval',
    Opinion = 'Opinion'
}

export const enum EStatusesTypes {
    Opinion = 'Opinion',
    Approved = 'Approved',
    Rejected = 'Rejected',
    Acknowledged = 'Acknowledged',
    Favorable = 'Favorable',
    Unfavorable = 'Unfavorable',
    Approval = 'Approval'
}

export interface IValidationStage {
    stageId: number;
    status: EStageStatus;
    validators: ISingleValidator[];
}

export interface ValidationResponse {
    businessId: {
        id: string,
        value: number,
        breadcrumb: string
    }
    context?: {
        type: string;
        referencedItem: {
            name: string;
            organizationId: string;
            id: string;
        }
    }
    createdAt: string;
    createdAutomatically: boolean;
    id: string;
    lastModifiedAt?: string;
    message?: string;
    readyForComplete: boolean;
    requestorId: string;
    resources?: {
        id: string;
        name: string;
        type: string;
        fileId?: string;
        contentType?: string;
        path: string;
    }[];
    skipFirstStep?: boolean;
    snapshot: string;
    stages: IValidationStage[];
    status: EValidationRequestStatus;
    subject?: string;
    validationStatusChangedAt?: Date;
}
export interface IGetSingleLastValidation {
    count: number;
    items: ValidationResponse[];
    itemsOnPageCount: number;
    page: number;
    size: number;
}

export interface IValidationState {
    isValid: boolean;
    message: string;
}

export interface IFormData {
    message: string;
    subject: string;
    referencedItem: {
        type: string;
        referencedItem: {
            id: string;
            name: string;
            organizationId: string;
        };
    };
    resources: {
        name: string;
        contentType?: string;
        fileId?: string;
        type: number;
        id: string;
        path?: string;
    }[];
    stages: {
        stageId: number;
        validators: {
            _rowId?: string;
            principal: {
                childId: string;
                childName: string;
                type: number;
                picture: string;
            };
            labelId: string;
            role: {
                id: string,
                name: string,
                key: string
              }
              validatorType: string;
        }[];
    }[];
    step?: number;
    isChecked?: boolean;
    step1Valid?: boolean;
}

export interface ITypesWithStatuses {
    type: string;
    translationKey: string;
    validatorStatuses: {
        translationKey: string;
        status: string;
    }[];
}

export enum EApprovalResourceType {
    Other = 0,
    ClusterOverview = 10,
    ClusterDocument = 20
}

export interface IApprovalPanelContext {
    showPanel: boolean;
    showComments: boolean;
    clusterId: string;
    validationId: string;
    status: EValidationRequestStatus;
    bussinesId: number;
    approvalClusterId?: string;
    setShowComments(state: boolean);
    setShowPanel(state: boolean);
    getTemplatesSettingsAndData?();
    setStatus(state: EValidationRequestStatus);
    setBussinesId(state: number);
}